





































































import Loading from 'vue-loading-overlay';
import { JourneysService } from '../../journeys/api/JourneysService';
import { Component, Prop, Vue, Emit, Watch, Mixins } from 'vue-property-decorator';
import { JourneysSummaryDataResponse } from '../../journeys/models/JourneysSummary';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { CompanyStoreHelper,NotificationStoreHelper } from '../../core/mixins';
import { ReportsServices } from '../../reports/api/ReportsServices';
import { Company, dateTypes, ReportSummaryResponse } from '../../core/models';
import { getDateFormattedAsMoment } from '../../core/utils/dates';
import { formatDate } from '../../core/utils';

@Component({
    components: { Loading }
})
export default class ReportsPreview extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    loadingInfo: boolean = false;
    errorMsg: string = 'No se pudo obtener el resumen de Reportes';
    defaultInfo: Array<object> = [];
    reportSummaryData: Array<object> = this.defaultInfo

    @Emit() handleRoute() {}


    setReportSummaryData(summaryData: Array<object>){
        this.reportSummaryData = summaryData;
    }


    @Watch('$_getSelectedCompany', {immediate: true, deep: true})
    watchSelectedCompany(company){
        this.getReportsInfo(company);
    }

    setLoadingInfo(value:boolean){
        this.loadingInfo = value
    }

    getReportsInfo(company:Company){
        let self = this;
        if(company && company.id){
            this.setLoadingInfo(true)
            this.setReportSummaryData(this.defaultInfo)
            ReportsServices.getSummaryByCompany(
                company.id
            ).then((res) => {
                this.setLoadingInfo(false);
                this.setReportSummaryData(res.reports);
            }).catch((error) => {
                this.setLoadingInfo(false);
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: self.errorMsg
                })
            }) 
        }
    }

    getParsedTime(time){
        let parsedTimed = '-';
        if(time !== ''){
            parsedTimed = formatDate(time);
        }
        return parsedTimed
    }

  

    @Emit() goToSettings() {}
}
